@if (open && config) {
    <!-- Backdrop -->
    <!-- Old backdrop
    <div 
        class="fixed inset-0 top-16 z-[99] bg-black/30 dark:bg-black/50 backdrop-blur-sm"
        @fadeBackdrop
        (click)="close()">
    </div>
    -->
    <div 
        class="fixed inset-0 top-16 z-[99] bg-black/10 backdrop-blur-[2px]"
        @fadeBackdrop
        (click)="close()">
    </div>
    
    <!-- Panel -->
    <!-- Old Panel styling
    <div 
        class="fixed top-16 right-0 bottom-0 z-[100] flex flex-col max-w-7xl
               bg-white dark:bg-slate-900 
               shadow-2xl shadow-slate-300/50 dark:shadow-black/50 
               border border-slate-200 dark:border-slate-800
               transition-all duration-300 ease-in-out"
        [style.width]="isSidebarCollapsed() ? 'calc(100% - 94px)' : 'calc(100% - 360px)'"
        @slidePanel>
    -->
    <div 
        class="fixed top-16 right-0 bottom-0 z-[100] flex flex-col max-w-7xl
               bg-white dark:bg-slate-900 overflow-hidden
               shadow-2xl shadow-slate-300/50 dark:shadow-black/50 
               border border-white/50 dark:border-slate-800
               transition-all duration-300 ease-in-out"
        [style.width]="isSidebarCollapsed() ? 'calc(100% - 120px)' : 'calc(100% - 360px)'"
        @slidePanel>

        <!-- Header -->
        <!-- Old Header
        <div class="relative overflow-hidden border-b border-slate-200 dark:border-slate-800 {{ accentClasses.headerBorder }}">
            <div class="absolute inset-0 bg-gradient-to-r {{ accentClasses.headerBg }} opacity-5 dark:opacity-10"></div>
            <div class="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br {{ accentClasses.headerBg }} opacity-10 dark:opacity-20 blur-[60px] rounded-full"></div>
            
            <div class="relative px-6 py-4">
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-4">
                        <button 
                            (click)="close()"
                            class="group flex items-center justify-center w-10 h-10 rounded-xl cursor-pointer transition-all duration-200 hover:scale-105 active:scale-95
                                   bg-slate-100 dark:bg-slate-800/80 
                                   border border-slate-200 dark:border-slate-700/60 
                                   text-slate-500 dark:text-slate-400 
                                   hover:bg-slate-200 dark:hover:bg-slate-800 
                                   hover:border-slate-300 dark:hover:border-slate-600 
                                   hover:text-slate-700 dark:hover:text-white">
                            <app-icon-v2 
                                name="arrowLeft" 
                                [size]="18"
                                class="group-hover:-translate-x-0.5 transition-transform duration-200">
                            </app-icon-v2>
                        </button>
                        
                        <div>
                            <h1 class="text-xl font-semibold tracking-tight text-slate-900 dark:text-white">{{ config.title }}</h1>
                            @if (config.subtitle) {
                                <p class="text-sm mt-0.5 text-slate-500 dark:text-slate-400">{{ config.subtitle }}</p>
                            }
                        </div>
                    </div>
                    
                    <div class="flex items-center gap-3">
                        <span class="px-3 py-1.5 text-xs font-bold uppercase tracking-wider rounded-lg border
                                     bg-slate-100 dark:bg-slate-800/80 
                                     text-slate-600 dark:text-slate-300 
                                     border-slate-200 dark:border-slate-700/50">
                            {{ filteredData().length }} Records
                        </span>
                    </div>
                </div>
            </div>
        </div>
        -->
        <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100 dark:border-slate-800/60 bg-slate-50/30 dark:bg-white/5 backdrop-blur-xl">
            <div class="flex items-center gap-4">
                <!-- Back button -->
                <button 
                    (click)="close()"
                    class="group flex items-center justify-center w-9 h-9 rounded-xl cursor-pointer transition-all duration-200
                           bg-white dark:bg-slate-800 
                           border border-slate-200 dark:border-slate-700
                           text-slate-400 dark:text-slate-400 
                           hover:bg-slate-50 dark:hover:bg-slate-700 
                           hover:text-slate-600 dark:hover:text-slate-200">
                    <app-icon-v2 
                        name="arrowLeft" 
                        [size]="16"
                        class="group-hover:-translate-x-0.5 transition-transform duration-200">
                    </app-icon-v2>
                </button>
                
                <div>
                    <h1 class="text-lg font-bold text-slate-800 dark:text-slate-100 leading-none mb-1">{{ config.title }}</h1>
                    @if (config.subtitle) {
                        <p class="text-xs font-medium text-slate-400 dark:text-slate-500">{{ config.subtitle }}</p>
                    }
                </div>
            </div>
            
            <div class="flex items-center gap-3">
                <span class="px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider rounded-lg
                             bg-slate-100 dark:bg-slate-800 
                             text-slate-500 dark:text-slate-400">
                    {{ filteredData().length }} RECORDS
                </span>
            </div>
        </div>
        
        <!-- Search & Filters -->
        <!-- Old Search & Filters
        <div class="px-6 py-4 border-b 
                    border-slate-200 dark:border-slate-800/80 
                    bg-slate-50/50 dark:bg-slate-900/50">
            <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div class="relative flex-1 max-w-md">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <app-icon-v2 name="search" [size]="16" class="text-slate-400 dark:text-slate-500"></app-icon-v2>
                    </div>
                    <input 
                        type="text"
                        [value]="searchQuery()"
                        (input)="onSearchInput($event)"
                        placeholder="Search records..."
                        class="w-full pl-10 pr-10 py-2 text-sm rounded-lg border transition-all duration-200
                               bg-white dark:bg-slate-800/80 
                               text-slate-800 dark:text-slate-200
                               placeholder-slate-400 dark:placeholder-slate-500
                               border-slate-200 dark:border-slate-700/60 
                               focus:outline-none focus:ring-2 focus:ring-offset-0
                               focus:ring-indigo-500/30 dark:focus:ring-indigo-500/40
                               focus:border-indigo-400 dark:focus:border-indigo-500/60
                               hover:border-slate-300 dark:hover:border-slate-600" />
                    @if (searchQuery()) {
                        <button 
                            (click)="clearSearch()"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer
                                   text-slate-400 dark:text-slate-500 
                                   hover:text-slate-600 dark:hover:text-slate-300 
                                   transition-colors duration-150">
                            <app-icon-v2 name="x" [size]="14"></app-icon-v2>
                        </button>
                    }
                </div>
    
                @if (config.enableMonthYearFilter && monthYearOptions().length > 0) {
                   ... (Old month filter code)
                }
    
                @if (config.filters && config.filters.length > 0) {
                    <div class="flex items-center gap-2 flex-wrap">
                        <span class="text-[10px] font-bold uppercase tracking-widest mr-1 text-slate-400 dark:text-slate-500">Filter:</span>
                        
                        <button 
                            (click)="setFilter('all')"
                            class="px-3 py-1.5 text-xs font-semibold rounded-lg border transition-all duration-200 cursor-pointer"
                            [class]="activeFilter() === 'all' ? accentClasses.filterActive : accentClasses.filterInactiveLight">
                            All
                        </button>
                        
                        @for (filter of config.filters; track filter.key) {
                            <button 
                                (click)="setFilter(filter.key)"
                                class="px-3 py-1.5 text-xs font-semibold rounded-lg border transition-all duration-200 cursor-pointer"
                                [class]="activeFilter() === filter.key ? accentClasses.filterActive : accentClasses.filterInactiveLight">
                                {{ filter.label }}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
        -->
        <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-800/60 bg-white dark:bg-slate-900">
            <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <!-- Search Bar -->
                <div class="relative min-w-[320px]">
                    <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                        <app-icon-v2 name="search" [size]="15" class="text-slate-400"></app-icon-v2>
                    </div>
                    <input 
                        type="text"
                        [value]="searchQuery()"
                        (input)="onSearchInput($event)"
                        placeholder="Search records..."
                        class="w-full pl-10 pr-10 py-2.5 text-[13px] font-medium rounded-2xl border transition-all duration-200
                               bg-white dark:bg-slate-800
                               text-slate-700 dark:text-slate-200
                               placeholder-slate-400 dark:placeholder-slate-500
                               border-slate-200 dark:border-slate-700
                               focus:outline-none focus:ring-2 focus:ring-offset-0
                               focus:ring-purple-500/10 focus:border-purple-400
                               hover:border-slate-300 dark:hover:border-slate-600" />
                    @if (searchQuery()) {
                        <button 
                            (click)="clearSearch()"
                            class="absolute inset-y-0 right-0 pr-3.5 flex items-center cursor-pointer
                                   text-slate-400 hover:text-slate-600 transition-colors">
                            <app-icon-v2 name="x" [size]="14"></app-icon-v2>
                        </button>
                    }
                </div>

                <div class="flex items-center gap-2 overflow-x-auto pb-1 sm:pb-0 scrollbar-hide">
                    <!-- Filter Config -->
                    @if (config.filters && config.filters.length > 0) {
                        <button 
                            (click)="setFilter('all')"
                            class="px-4 py-2 text-[11px] font-bold rounded-xl border transition-all duration-200 cursor-pointer whitespace-nowrap"
                            [class]="activeFilter() === 'all' 
                                ? 'bg-purple-50 text-purple-600 border-purple-100 dark:bg-purple-900/20 dark:text-purple-300 dark:border-purple-800/50 shadow-sm shadow-purple-500/10' 
                                : 'bg-white text-slate-500 border-slate-200 hover:border-purple-200 hover:text-purple-600 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:text-white'">
                            All
                        </button>
                        
                        @for (filter of config.filters; track filter.key) {
                            <button 
                                (click)="setFilter(filter.key)"
                                class="px-4 py-2 text-[11px] font-bold rounded-xl border transition-all duration-200 cursor-pointer whitespace-nowrap"
                                [class]="activeFilter() === filter.key 
                                    ? 'bg-purple-50 text-purple-600 border-purple-100 dark:bg-purple-900/20 dark:text-purple-300 dark:border-purple-800/50 shadow-sm shadow-purple-500/10' 
                                    : 'bg-white text-slate-500 border-slate-200 hover:border-purple-200 hover:text-purple-600 dark:bg-slate-800 dark:border-slate-700 dark:text-slate-400 dark:hover:text-white'">
                                {{ filter.label }}
                            </button>
                        }
                    }
                </div>
            </div>
        </div>
        
        <!-- Table Container -->
        <!-- Old Table Container
        <div class="flex-1 overflow-auto bg-white dark:bg-slate-900">
            <table class="w-full">
                <thead class="sticky top-0 z-10">
                    <tr class="border-b 
                               bg-slate-50/95 dark:bg-slate-800/90 
                               backdrop-blur-sm 
                               border-slate-200 dark:border-slate-700/50">
                        @for (column of config.columns; track column.key) {
                            <th 
                                class="px-4 py-3 text-left text-[10px] font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400"
                                [style.width]="column.width || 'auto'">
                                {{ column.label }}
                            </th>
                        }
                    </tr>
                </thead>
                
                <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60">
                   ... (Old table body content)
                </tbody>
            </table>
        </div>
        -->
        <div class="flex-1 overflow-auto bg-slate-50/50 dark:bg-slate-900/50 rounded-b-2xl">
            <table class="w-full">
                <!-- Table Header -->
                <thead class="sticky top-0 z-10">
                    <tr class="border-b border-slate-200/60 dark:border-slate-700/50 bg-slate-50/80 dark:bg-slate-900/90 backdrop-blur-sm text-left">
                        @for (column of config.columns; track column.key) {
                            <th class="px-6 py-3.5 text-[10px] font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400"
                                [style.width]="column.width || 'auto'">
                                {{ column.label }}
                            </th>
                        }
                    </tr>
                </thead>
                
                <!-- Table Body -->
                <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60 bg-white dark:bg-slate-900">
                    @if (filteredData().length === 0) {
                        <tr>
                            <td [attr.colspan]="config.columns.length" class="px-6 py-20 text-center">
                                <div class="flex flex-col items-center gap-3">
                                    <div class="w-16 h-16 rounded-2xl flex items-center justify-center bg-slate-50 dark:bg-slate-800">
                                        <app-icon-v2 name="inbox" [size]="24" class="text-slate-400"></app-icon-v2>
                                    </div>
                                    <p class="text-sm font-medium text-slate-500">No records found</p>
                                </div>
                            </td>
                        </tr>
                    } @else {
                        @for (item of filteredData(); track $index) {
                            <tr class="group transition-colors duration-200 hover:bg-slate-50/80 dark:hover:bg-slate-800/40">
                                @for (column of config.columns; track column.key) {
                                    <td class="px-6 py-4 align-top">
                                        @switch (column.type) {
                                            @case ('status') {
                                                <span 
                                                    class="inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wide rounded-lg border {{ getStatusClasses(item[column.key]) }}">
                                                    <span class="w-1.5 h-1.5 rounded-full bg-current opacity-60"></span>
                                                    {{ item[column.key] || 'Unknown' }}
                                                </span>
                                            }
                                            @case ('badge') {
                                                <span class="inline-flex items-center justify-center px-3 py-1.5 text-[11px] font-medium rounded-lg border
                                                             bg-slate-100 text-slate-600 border-slate-200
                                                             dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700">
                                                    {{ item[column.key] || '-' }}
                                                </span>
                                            }
                                            @case ('currency') {
                                                <span class="text-sm font-semibold tabular-nums text-emerald-600 dark:text-emerald-400">
                                                    {{ item[column.key] || 0 | currency }}
                                                </span>
                                            }
                                            @case ('date') {
                                                <div class="flex flex-col gap-1">
                                                    <span class="text-[13px] font-medium text-slate-700 dark:text-slate-200 leading-none">
                                                        {{ formatValue(item, column) }}
                                                    </span>
                                                    @if (item.slot_name || item.slot_label || item.slot) {
                                                        <span class="text-[10px] font-normal uppercase tracking-wider text-slate-400">
                                                            {{ item.slot_name || item.slot_label || item.slot }}
                                                        </span>
                                                    }
                                                </div>
                                            }
                                            @default {
                                                @if (column.key === 'contract' || column.key === 'contract_code') {
                                                    <div class="flex flex-col gap-1">
                                                        <span class="text-[13px] font-medium text-slate-800 dark:text-slate-100 leading-none">
                                                            {{ item[column.key] || '-' }}
                                                        </span>
                                                        @if (item.created_by || item.admin_name) {
                                                            <span class="text-[11px] font-normal text-slate-400">
                                                                by {{ item.created_by || item.admin_name }}
                                                            </span>
                                                        }
                                                    </div>
                                                } @else {
                                                    <span class="text-[13px] font-normal text-slate-400 dark:text-slate-300">
                                                        {{ formatValue(item, column) }}
                                                    </span>
                                                }
                                            }
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
    </div>
}
